import React from "react";
import { Routes, Route } from "react-router-dom";
// import Home from "../pages/Home";
// import Checkout from "../pages/Checkout";
import GetTicketPage from "../pages/GetTicket";
// import TyPage from "../pages/TyPage";
// import Confirmation from "../pages/Confirmation";
import TyPage from "../pages/GetTicket/TyPage";
import Confirmation from "../pages/GetTicket/Confirmation";
import Eula from "../pages/Burger/Eula";
import PrivacyPolicy from "../pages/Burger/PrivacyPolicy";
import TermsConditions from "../pages/Burger/TermsCondition";

const AppRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<Home />} /> */}
      <Route path="/" element={<GetTicketPage />} />
      <Route path="/transaction" element={<TyPage />} />
      <Route path="/confirmation" element={<Confirmation />} />
      <Route path="/terms-and-conditions" element={<TermsConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/end-user-license-agreement" element={<Eula />} />
    </Routes>
  );
};

export default AppRoutes;
